//@flow
import Constants from '../constants';
import Dispatcher from '../dispatcher';

export default {
  updateUXData(data:Object) {
    Dispatcher.dispatchAction(Constants.FREE_GIFT_UPDATE_UX, data);
  },
};
